export default __webpack_public_path__ + "static/media/external-users-welcome-graphic.dc0e20b6.png";